import { useRef, useState } from "react";

const SWIPE_DISTANCE = 30;       // px needed to switch
const SWIPE_VELOCITY = 0.4;     // fast flick threshold
const RUBBER_BAND = 0.50;       // resistance strength
const ANGLE_LOCK = 0.5;         // y/x ratio → reject vertical

export default function SwipeGuard({
  children,
  activeSection,
  setActiveSection,
}) {
  const startX = useRef(0);
  const startY = useRef(0);
  const startTime = useRef(0);

  const [dragX, setDragX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const sections = ["status", "config", "tradebook", "logs", "journal"];
  const index = sections.indexOf(activeSection);

  // 🔹 Rubber-band physics (Groww style)
  const applyResistance = (delta) => {
    return delta * RUBBER_BAND;
  };
  const shouldIgnoreSwipe = (e) => {
  return e.target.closest("[data-swipe-ignore]");
};


  const onTouchStart = (e) => {
    if (shouldIgnoreSwipe(e)) return;
    const t = e.touches[0];
    startX.current = t.clientX;
    startY.current = t.clientY;
    startTime.current = Date.now();
    setIsDragging(true);
  };

  const onTouchMove = (e) => {
    if (shouldIgnoreSwipe(e)) return;
    if (!isDragging) return;

    const t = e.touches[0];
    const dx = t.clientX - startX.current;
    const dy = t.clientY - startY.current;

    // 🚫 Reject vertical / diagonal intent
    if (Math.abs(dy) > Math.abs(dx) * ANGLE_LOCK) {
      setDragX(0);
      return;
    }

    // 🧲 Rubber-band resistance
    setDragX(applyResistance(dx));
  };

  const onTouchEnd = () => {
    const elapsed = Date.now() - startTime.current;
    const velocity = Math.abs(dragX) / elapsed;

    let nextIndex = index;

    if (
      Math.abs(dragX) > SWIPE_DISTANCE ||
      velocity > SWIPE_VELOCITY
    ) {
      if (dragX < 0 && index < sections.length - 1) {
        nextIndex = index + 1;
      } else if (dragX > 0 && index > 0) {
        nextIndex = index - 1;
      }
    }

    setDragX(0);
    setIsDragging(false);

    if (nextIndex !== index) {
      setActiveSection(sections[nextIndex]);
    }
  };
 

  return (
    <div
      className="relative overflow-hidden touch-pan-y"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div
        className={`
          will-change-transform
          ${isDragging
            ? "transition-none"
            : "transition-transform duration-300 ease-out"}
        `}
        style={{
          transform: `translate3d(${dragX}px, 0, 0)`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
